module.exports = __webpack_public_path__ + "static/media/FORMATO CERTIFICADO LABORAL DETALLADO.e74c8134.pdf";